import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { initSurvicate } from '@survicate/survicate-web-surveys-wrapper/widget_wrapper'

import { ProtectedRoute } from './routing/ProtectedRoute'
import { publicRoutes } from './routing/public.routes'
import { protectedRoutes } from './routing/protected.routes'
import FourOhFour from './views/Auth/FourOhFour'
import { fullstoryScript } from './utils/constants'
import { useDarkModeSetting } from './utils/hooks/useTheme'

const App = () => {
  const { currentOrganization } = useSelector((state) => state)
  const user = JSON.parse(localStorage.getItem('User'))

  useDarkModeSetting()

  useEffect(() => {
    if (user) {
      const traits = {
        orgName: user.organization_name,
        orgId: user.organizationid,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.username,
        isBaltoCloud: true,
        role: user.metrics_job_function ? user.metrics_job_function : 'NONE',
      }

      initSurvicate({ workspaceKey: '9651cb7004c218d5ef487eefec227349', traits })
    }
  }, [user?.user_id])

  useEffect(() => {
    if (currentOrganization.id && !currentOrganization.unredacted_enabled) {
      const script = document.createElement('script')
      script.textContent = fullstoryScript
      script.setAttribute('data-testid', 'fullstory-script-tag')
      script.async = true
      document.head.appendChild(script)

      return () => {
        document.head.removeChild(script)
        delete window.FS
      }
    }

    return undefined
  }, [currentOrganization.id])

  useEffect(() => {
    if (window.FS && user) {
      window.FS('setIdentity', {
        uid: user.user_id,
        properties: {
          displayName: `${user.first_name} ${user.last_name}`,
          email: user.username,
          organization: {
            name: user.organization_name,
            id: user.organizationid,
          },
          role: user.metrics_job_function ? user.metrics_job_function : 'NONE',
        },
      })
    }
  }, [window.FS])

  // churnzero
  useEffect(() => {
    if (currentOrganization.salesforce_id && process.env.CHURNZERO_APP_KEY) {
      const script = document.createElement('script')
      script.src = 'https://balto.us1app.churnzero.net/churnzero.js'
      script.setAttribute('data-testid', 'churnzero-script-tag')
      script.async = true
      document.head.appendChild(script)

      return () => {
        document.head.removeChild(script)
        delete window.ChurnZero
      }
    }

    return undefined
  }, [currentOrganization.salesforce_id])

  useEffect(() => {
    if (window.ChurnZero && user && process.env.CHURNZERO_APP_KEY) {
      window.ChurnZero.push(['setAppKey', process.env.CHURNZERO_APP_KEY])
      window.ChurnZero.push(['setContact', currentOrganization.salesforce_id, user.username])
    }
  }, [window.ChurnZero])

  return (
    <Switch>
      {publicRoutes.map(({ exact = true, path, Component }) => (
        <Route exact={exact} key={path} path={path} component={Component} />
      ))}
      {protectedRoutes.map(({ exact = true, path, Component, ...props }) => (
        <ProtectedRoute exact={exact} key={path} path={path} component={Component} {...props} />
      ))}
      <Route path="*" component={FourOhFour} />
    </Switch>
  )
}

export default App
